<script setup lang="ts">
import { toRefs } from 'vue';
import { useField } from 'vee-validate';
import { z } from 'zod';
import { toTypedSchema } from '@vee-validate/zod';
import SelectField from '@shared/form/SelectField/SelectField.vue';
import FieldRowV2 from '@shared/form/FieldRowV2/FieldRowV2.vue';

const props = defineProps<{
  options: Array<{ label: string; value: string; disabled?: boolean; description?: string }>;
  tooltip?: string;
  disabled: boolean;
}>();
const { options, disabled, tooltip } = toRefs(props);

const schema = toTypedSchema(z.string());
const { value, errorMessage } = useField<string>('incassotermijn', schema);
</script>

<template>
  <FieldRowV2
    :errors="[errorMessage]"
    label="Incassotermijn"
    label-for="incassotermijn"
    label-on-own-row
    label-text-color="primary900"
    :tooltip
    data-testid="incassotermijn"
  >
    <SelectField id="incassotermijn" v-model:value="value" :options :disabled />
  </FieldRowV2>
</template>
